// AddressForm.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, firestore } from "../../../firebaseConfig";
import { collection, doc, setDoc, getDoc } from "firebase/firestore"; // Import Firestore functions
import * as S from "./styles"; // Import your styles

type AddressFormProps = {
    setAddress: (value: string) => void; // Change this to (value: string) => void
    setShowAddressForm: (value: boolean) => void;
    setShowDeliveryOptions: (value: boolean) => void;
  };
  
  

const AddressForm: React.FC<AddressFormProps> = ({ setAddress, setShowAddressForm, setShowDeliveryOptions }) => { // Add setShowDeliveryOptions here
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [streetAddress, setStreetAddress] = useState("");
    const [complexName, setComplexName] = useState("");
    const [suburb, setSuburb] = useState("");
    const [city, setCity] = useState("");
    const [poBox, setPoBox] = useState("");
    const [country, setCountry] = useState("");
  
    useEffect(() => {
      const fetchUserDetails = async () => {
        if (auth.currentUser) {
          const userDoc = doc(collection(firestore, "users"), auth.currentUser.uid);
          const docSnap = await getDoc(userDoc);
  
          if (docSnap.exists()) {
            const userDetails = docSnap.data();
            setFirstName(userDetails.firstName || "");
            setLastName(userDetails.lastName || "");
            setEmail(userDetails.email || "");
            setPhoneNumber(userDetails.phoneNumber || "");
            setStreetAddress(userDetails.streetAddress || "");
            setComplexName(userDetails.complexName || "");
            setSuburb(userDetails.suburb || "");
            setCity(userDetails.city || "");
            setPoBox(userDetails.poBox || "");
            setCountry(userDetails.country || "");
          }
        }
      };
  
      fetchUserDetails();
    }, []);
  
    const handleAddressSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
      
        if (auth.currentUser) {
          // Save the address in Firestore
          const userDoc = doc(collection(firestore, "users"), auth.currentUser.uid);
          await setDoc(userDoc, {
            firstName,
            lastName,
            email,
            phoneNumber,
            streetAddress,
            complexName,
            suburb,
            city,
            poBox,
            country,
          }, { merge: true });
      
          console.log("Saved address: ", streetAddress); // Add this line
          setAddress(streetAddress);
          setShowAddressForm(false); // Close the address form
          setShowDeliveryOptions(true); // Reopen the delivery form
        }
      };
      


      const handleCancel = () => {
        setShowAddressForm(false); // Hide the address form
        setShowDeliveryOptions(true); // Reopen the delivery form
      };

  return (
    <S.AddressForm onSubmit={handleAddressSubmit}>
      <S.Input type="text" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
      <S.Input type="text" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
      <S.Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <S.Input type="tel" placeholder="Phone Number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
      <S.Input type="text" placeholder="Street Address" value={streetAddress} onChange={(e) => setStreetAddress(e.target.value)} />
      <S.Input type="text" placeholder="Complex / Building Name / Unit Number (optional)" value={complexName} onChange={(e) => setComplexName(e.target.value)} />
      <S.Input type="text" placeholder="Suburb" value={suburb} onChange={(e) => setSuburb(e.target.value)} />
      <S.Input type="text" placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} />
      <S.Input type="text" placeholder="PO BOX" value={poBox} onChange={(e) => setPoBox(e.target.value)} />
      <S.Input type="text" placeholder="Country" value={country} onChange={(e) => setCountry(e.target.value)} />
      <S.Button type="submit">Save Address</S.Button>
      <S.Button type="button" onClick={handleCancel}>Cancel</S.Button> {/* Add this line */}
    </S.AddressForm>

  );
};

export default AddressForm;
